import React from 'react';

const TarapacaTnCSection = props => {
	const createMarkup = data => {
		return {
			__html: data,
		};
	};

	// Determine the background color based on the operator
	const backgroundColor = props.operator && props.operator.operator_name === 'biaggini'
		? '#0092c5'
		: props.operator &&
			props.operator.color_codes &&
			props.operator.color_codes.secondary_color
			? props.operator.color_codes.secondary_color
			: undefined; // Use existing logic for other operators

	return (
		<div
			className="themes-theme-two-tn-c-section new-container"
			style={{
				background: backgroundColor
			}}
		>
			<style>
				{`.color {
          color: ${props.operator &&
						props.operator.color_codes &&
						props.operator.color_codes.button_color
						? props.operator.color_codes.button_color
						: 'inherit'  // Set default color handling if not defined
					};
        }`}
			</style>
			<div
				dangerouslySetInnerHTML={createMarkup(
					props.operator && props.operator.terms ? props.operator.terms : '',
				)}
				className="lh-1-3 justify-text less-bold-text"
			/>
			<p></p>
		</div>
	);
};
export default TarapacaTnCSection;



// WEBPACK FOOTER //
// ./src/features/themes/Cormarbus/common/CormarbusTnCSection.js